import React from 'react'
import { Typography } from '../..'
import styles from './styles.module.css'
import { cn } from '@s4l/utility-css'
import { IconCheck } from '@s4l/icons/IconCheck'

interface IconProps {
  size?: number
  color?: string
  selected?: boolean
}

interface IDropdownSelectorProps<T extends React.ElementType = 'a'> {
  component?: T
  target?: string
  children: React.ReactNode
  leadingIcon?: React.ReactElement<IconProps>
  trailingIcon?: React.ReactElement<IconProps>
  selected?: boolean
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
}

export default function DropdownSelector<T extends React.ElementType = 'a'>(
  props: IDropdownSelectorProps<T> & React.ComponentProps<T>
) {
  const {
    component: Component = 'a',
    target,
    children,
    leadingIcon,
    trailingIcon,
    onClick,
    selected,
    ...rest
  } = props

  return (
    <Component
      className={cn(styles.dropdownSelector, {
        [styles.selected]: selected,
      })}
      target={target}
      rel="noreferrer noopener"
      onClick={onClick}
      {...rest}
    >
      {leadingIcon}
      <Typography variant="body" size="l" className="flex-grow-1" ellipsis>
        {children}
      </Typography>
      {selected && (
        <IconCheck data-testid="icon-check" size={24} color="var(--color-primary-500)" />
      )}
      {!selected && trailingIcon}
    </Component>
  )
}
